import { AuthUser } from "../../types/models/AuthUser";

export const authRole = {
  user: "user",
  admin: ["user", "admin"],
  superuser: ["user", "admin", "pim"],
};

export enum RoutePermittedRole {
  Admin = "admin",
  User = "user",
  PIM = "pim",
}

export const defaultUser: AuthUser = {
  uid: "john-alex",
  displayName: "John Alex",
  email: "demo@example.com",
  token: "access-token",
  role: "user",
  photoURL: "/assets/images/placeholder.jpg",
};
export const initialUrl = "/warehouse/start"; // this url will open after login
